import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Services from '../components/Services';
import Industries from '../components/Industries';
import Testimonials from '../components/Testimonials';
import Portal from '../components/Portal';
import FAQ from '../components/FAQ';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: 'https://wayug.com/',
    },
  ],
};

const Home = () => {
  return (
    <div className="page-content">
      <Helmet>
        <title>Enterprise IT Services &amp; Custom Software Development | Wayug Infotech</title>
        <meta
          name="description"
          content="Wayug Infotech — India's trusted enterprise IT partner. Cloud migration, cybersecurity, AI automation &amp; custom software for 50+ companies. Get a free IT assessment today."
        />
        <link rel="canonical" href="https://wayug.com/" />
        <meta property="og:title" content="Enterprise IT Services &amp; Custom Software Development | Wayug Infotech" />
        <meta
          property="og:description"
          content="Cloud migration, cybersecurity, AI automation &amp; custom software development for enterprises across India. Trusted by 50+ companies."
        />
        <meta property="og:url" content="https://wayug.com/" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
      <Hero />
      <Stats />
      <Services />
      <Industries />
      <Testimonials />
      <FAQ />
      <Portal />
    </div>
  );
};

export default Home;
